// Веб-кабинет SellerAlert (репозиторий front). Mini App ведёт туда сценарии,
// которых в Telegram нет: юридические документы, запрос доступа к кабинету.
export const FRONT_URL = "https://app.seller-alert.com";
